import React, { useState } from 'react';
import { FiStar, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { FaQuoteLeft } from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Priya Sharma',
      location: 'Mumbai',
      condition: 'Chronic Back Pain',
      rating: 5,
      text: 'After 5 years of chronic back pain, Dr. Singh\'s treatment gave me my life back. No surgery, no medicines - just natural healing. Highly recommended!',
      image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face'
    },
    {
      name: 'Rajesh Kumar',
      location: 'Thane',
      condition: 'Cervical Spondylosis',
      rating: 5,
      text: 'The team at JIVA NADI is exceptional. My neck pain is completely gone after just 6 sessions. The personalized care makes all the difference.',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
    },
    {
      name: 'Meera Patel',
      location: 'Pune',
      condition: 'Sciatica',
      rating: 5,
      text: 'I was skeptical about non-surgical treatment, but Dr. Singh proved me wrong. My sciatica pain disappeared completely in 4 weeks. Amazing results!',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
    },
    {
      name: 'Amit Desai',
      location: 'Mumbai',
      condition: 'Sports Injury',
      rating: 5,
      text: 'As a professional athlete, I needed quick recovery. JIVA NADI\'s treatment got me back to peak performance faster than I expected. Truly professional!',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            What Our Patients Say
          </h2>
          <p className="text-lg text-gray-700 mb-6">
            Real stories from real patients who found lasting pain relief at JIVA NADI
          </p>
          <div className="inline-flex items-center space-x-2 bg-emerald-50 px-6 py-3 rounded-full border border-emerald-200">
            <div className="flex text-yellow-400">
              {[...Array(5)].map((_, i) => (
                <SafeIcon key={i} icon={FiStar} className="w-5 h-5 fill-current" />
              ))}
            </div>
            <span className="text-gray-700 font-semibold">4.9/5 from 117+ Verified Reviews</span>
          </div>
        </div>

        {/* Slider Container */}
        <div className="relative">
          {/* Slides */}
          <div className="overflow-hidden">
            <div className="flex transition-transform duration-500 ease-in-out" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
              {testimonials.map((testimonial, index) => (
                <div key={index} className="min-w-full px-4">
                  <div className="bg-gradient-to-br from-emerald-50 to-white rounded-2xl p-8 md:p-12 shadow-lg border border-emerald-100 relative max-w-2xl mx-auto">
                    {/* Quote Icon */}
                    <div className="absolute top-6 right-6">
                      <SafeIcon icon={FaQuoteLeft} className="w-8 h-8 text-emerald-200" />
                    </div>

                    {/* Rating */}
                    <div className="flex text-yellow-400 mb-4">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <SafeIcon key={i} icon={FiStar} className="w-5 h-5 fill-current" />
                      ))}
                    </div>

                    {/* Testimonial Text */}
                    <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-8 italic">
                      "{testimonial.text}"
                    </p>

                    {/* Patient Info */}
                    <div className="flex items-center space-x-4">
                      <img 
                        src={testimonial.image} 
                        alt={testimonial.name}
                        className="w-16 h-16 rounded-full object-cover border-4 border-white shadow-lg"
                      />
                      <div>
                        <h4 className="text-xl font-semibold text-gray-900">
                          {testimonial.name}
                        </h4>
                        <p className="text-emerald-600 font-medium">
                          {testimonial.condition}
                        </p>
                        <p className="text-gray-500 text-sm">
                          {testimonial.location}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-6 md:-translate-x-12 bg-white shadow-lg hover:shadow-xl rounded-full p-3 text-emerald-600 hover:bg-emerald-50 transition-all duration-300 z-10"
          >
            <SafeIcon icon={FiChevronLeft} className="w-6 h-6" />
          </button>
          
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-6 md:translate-x-12 bg-white shadow-lg hover:shadow-xl rounded-full p-3 text-emerald-600 hover:bg-emerald-50 transition-all duration-300 z-10"
          >
            <SafeIcon icon={FiChevronRight} className="w-6 h-6" />
          </button>

          {/* Dots Navigation */}
          <div className="flex justify-center items-center gap-3 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex ? 'bg-emerald-600 w-8' : 'bg-emerald-200 w-3 hover:bg-emerald-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;